export const student = {
    // 作业列表页面
    "student_homework_title": "我的作业",
    "student_homework_load_error": "加载作业列表失败",
    "student_homework_load_detail_error": "加载作业详情失败",
    "student_homework_no_class": "您还未加入任何班级",
    "student_homework_no_homework": "暂无可用作业",
    "student_homework_no_data": "暂无数据",

    // 筛选和搜索
    "student_homework_select_class": "选择班级",
    "student_homework_all_subjects": "全部科目",
    "student_homework_search_placeholder": "搜索作业名称或描述",
    "student_homework_class_ended": "已结课",

    // 表格列
    "student_homework_column_name": "名称",
    "student_homework_column_subject": "科目",
    "student_homework_column_description": "描述",
    "student_homework_column_use_time": "时长",
    "student_homework_column_score": "成绩",
    "student_homework_column_created_at": "创建时间",
    "student_homework_column_actions": "操作",

    // 统计
    "student_homework_current_class": "当前班级",
    "student_homework_total_count": "作业总数",
    "student_homework_available": "可作答数",
    "student_homework_total": "共 {{total}} 项",

    // 操作按钮
    "student_homework_start": "开始作答",
    "student_homework_continue": "继续作答",
    "student_homework_view": "查看",
    "student_homework_load_more": "加载更多",
    "student_homework_refresh": "刷新",
    "student_homework_view_mode_card": "卡片视图",
    "student_homework_view_mode_list": "列表视图",

    // 时间单位
    "student_homework_minutes": "分钟",
    "student_homework_seconds": "秒",

    // 作业详情/作答 Modal
    "student_homework_preview": "预览",
    "student_homework_answered": "已答",
    "student_homework_not_answered": "未作答",
    "student_homework_your_answer": "你的答案",
    "student_homework_simple_text_placeholder": "请输入您的答案",
    "student_homework_true": "正确",
    "student_homework_false": "错误",

    // 作答状态
    "student_homework_progress": "答题进度",
    "student_homework_use_time_limit": "限时",
    "student_homework_completion_rate": "完成率",
    "student_homework_finished": "已完成",
    "student_homework_wait_grade": "等待老师批改",
    "student_homework_wait_grade_desc": "您已提交作业，请等待老师批改后查看成绩",
    "student_homework_your_answers": "您的答案",
    "student_homework_score_display": "得分：{{score}} / {{total}}",

    // 作业详情
    "student_homework_answer_detail": "答题详情",
    "student_homework_start_time": "开始时间",
    "student_homework_end_time": "结束时间",
    "student_homework_answer_restored": "已恢复之前的答案",

    // 操作按钮
    "student_homework_back": "返回",
    "student_homework_cancel": "取消",
    "student_homework_close": "关闭",
    "student_homework_save_cache": "暂存",
    "student_homework_submit": "提交",

    // 确认对话框
    "student_homework_submit_confirm_title": "确认提交",
    "student_homework_submit_confirm_content": "您已作答 {{answered}}/{{total}} 题，确定要提交吗？",
    "student_homework_unanswered_warning": "您还有未填写的题目（已作答 {{answered}}/{{total}}），已为您定位到第一个未填写的题目",

    // 操作结果
    "student_homework_save_success": "暂存成功",
    "student_homework_save_error": "暂存失败",
    "student_homework_submit_success": "作业提交成功",
    "student_homework_submit_error": "作业提交失败",

    // Tab 标签
    "student_homework_tab_all": "全部作业",
    "student_homework_tab_not_answered": "未答题",
    "student_homework_tab_questions": "题目",
    "student_homework_tab_question_distribution": "题目分布",
    "student_homework_tab_answer_result": "答题结果",

    // 答题模式
    "student_homework_single_mode": "逐题模式",
    "student_homework_multiple_mode": "多题模式",
    "student_homework_prev": "上一题",
    "student_homework_next": "下一题",
    "student_homework_question_navigation": "题目导航",
    "student_homework_no_question": "暂无题目",
    "homework_temp_part": "部分",
    
    // 答案显示
    "student_homework_correct_answer": "正确答案",
    "student_homework_your_answer_label": "你的答案",
    "student_homework_correct": "正确",
    "student_homework_incorrect": "错误",
    "student_homework_partial_correct": "部分正确",
    "student_homework_question_score": "得分",
    "student_homework_teacher_comment": "老师备注",
    "student_homework_score_rate": "得分率",
    "student_homework_objective_correct_count": "客观题正确数",
    "student_homework_objective_total_count": "客观题总题数",
    "student_homework_objective_correct_rate": "客观题正确率",
    "student_homework_filter_partial": "部分正确",
    
    // 题目分布和答题结果
    "student_homework_question_type": "题目类型",
    "student_homework_correct_count": "正确数",
    "student_homework_question_total_count": "总题数",
    "student_homework_correct_rate": "正确率",
    "student_homework_total_score": "总分",
    "student_homework_actual_score": "得分",
    "student_homework_use_time_label": "用时",
    "student_homework_no_answer_detail": "暂无答题详情",
    
    // 筛选和未填写题目
    "student_homework_filter_questions": "筛选题目",
    "student_homework_filter_all": "全部",
    "student_homework_filter_correct": "正确",
    "student_homework_filter_incorrect": "错误",
    "student_homework_filter_unanswered": "未填写",
    "student_homework_unanswered_questions_title": "未填写题目",
    "student_homework_unanswered_questions": "共有 {{count}} 题未填写，题目编号：{{indices}}",
    "student_homework_no_filtered_questions": "没有符合条件的题目",

    // 班级列表
    "student_class_title": "我的班级",
    "student_class_load_error": "加载班级列表失败",
    "student_class_no_classes": "暂无班级",
    "student_class_search_placeholder": "搜索班级名称或描述",
    "student_class_status_init": "初始化",
    "student_class_status_running": "进行中",
    "student_class_status_end": "已结束",
    "student_class_status_disabled": "已禁用",
    "student_class_start_time": "开始时间",
    "student_class_end_time": "结束时间",
    "student_class_enter_class": "进入班级",
    "student_class_view_detail": "查看详情",
    "student_class_view_mode_cards": "卡片视图",
    "student_class_view_mode_list": "列表视图",

    // 班级详情
    "student_class_detail_title": "班级详情",
    "student_class_detail_info": "班级信息",
    "student_class_detail_homework": "作业",
    "student_class_detail_teachers": "老师",
    "student_class_detail_students": "学生",
    "student_class_detail_description": "描述",
    "student_class_detail_status": "状态",
    "student_class_detail_no_description": "暂无描述",

    // 考试模式
    "student_homework_tab_online_exam": "线上考试",
    "student_homework_exam_tag": "考试",
    "student_homework_start_exam": "开始考试",
    "student_homework_continue_exam": "继续考试",
    "student_exam_start_title": "在线考试",
    "student_exam_start_alert": "请确认后开始考试",
    "student_exam_start_hint": "开始后将立即计时，超时系统自动提交",
    "student_exam_start_description": "考试过程中请独立完成，不要刷新或关闭页面。剩余时间将显示在页面顶部。",
    "student_exam_start_button": "开始考试",
    "student_exam_duration_label": "考试时长：{{minutes}} 分钟",
    "student_exam_auto_submit_success": "考试时间到，已自动提交",
    "student_exam_time_remaining": "剩余时间",
    "student_exam_duration_column": "限时",
};
